import React, { useCallback } from 'react';
import { stubTrue } from 'lodash';
import { DropdownField } from 'modules/campaigns/components/Form';
import { FORM_MODES } from 'modules/campaigns/config';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { validationFunctions } from 'modules/taboola-common-frontend-modules/validations';
import { CONVERSION_TYPE } from '../../config';
import { useConversionCategory } from '../../hooks/useConversionCategory';
import styles from './conversionCategoryField.module.scss';

const dropdownValidations = [
    {
        validationFn: validationFunctions.isIn,
        messageId: 'tracking.conversion.form.category.validations.error',
        defaultMessage: 'Select a Category',
    },
];

export const ConversionCategoryField = ({
    id = 'conversionCategory',
    field = 'category',
    showDescription = true,
    skipValidations,
    disabled = false,
    selectedCategories = [],
    isCodeless = false,
    categories,
    ...props
}) => {
    const conversionCategories = useConversionCategory();
    const categoryOptions = categories || conversionCategories;
    const { value: categoryVal, onChange, mode } = useFormFieldValue({ field });
    const { onChange: onChangeEventName } = useFormFieldValue({ field: 'eventName' });
    const { value: type } = useFormFieldValue({ field: 'type' });

    const filteredCategories = categoryOptions.filter(
        category => !selectedCategories.includes(category.value) || category.value === categoryVal
    );

    const category = filteredCategories.find(categoryObj => categoryObj.value === categoryVal) || {
        value: categoryVal,
        label: categoryOptions.find(cat => cat.value === categoryVal)?.label || undefined,
    };

    const onCategoryChange = useCallback(
        category => {
            onChange(category.value);
            if (type === CONVERSION_TYPE.EVENT_BASED) {
                onChangeEventName(category.value.toLowerCase());
            }
        },
        [type, onChangeEventName, onChange]
    );
    const isDescription = (mode === FORM_MODES.CREATE && showDescription) || (showDescription && isCodeless);

    return (
        <div className={styles['container']}>
            <DropdownField
                dropdownWrapperClassName={styles['dropdown-wrapper']}
                label={<FormattedMessage id="tracking.conversion.form.category.label" defaultMessage="Category" />}
                description={
                    isDescription && (
                        <FormattedMessage
                            id="tracking.conversion.form.category.description"
                            defaultMessage="Choose the category that best describes the conversion you're defining."
                        />
                    )
                }
                id={id}
                placeholder={
                    <FormattedMessage
                        id="tracking.conversion.form.category.placeholder"
                        defaultMessage="Select event category"
                    />
                }
                selectedValueObject={category}
                options={filteredCategories}
                onChange={onCategoryChange}
                validations={skipValidations ? [{ validationFn: stubTrue }] : dropdownValidations}
                searchable
                disabled={disabled || mode === FORM_MODES.EDIT}
                {...props}
            />
        </div>
    );
};
